<button (click)="dialog.showModal()">
  <ng-content (click)="dialog.showModal()" />
</button>

<ui-simple-dialog #dialog [lazy]="true">
  <form class="w-full" (submit.prevent)="onSubmit()">
    <ui-simple-dialog-layout (clickCancel)="dialog.close()" class="w-full">
      <h2 slot="title">{{ 'cockpit.supplierContracts.contactButton.dialog.title' | transloco }}</h2>

      <div class="flex flex-col gap-4">
        <ui-radio-group
          [formField]="contactForm.subject"
          [attr.aria-label]="
            'cockpit.supplierContracts.contactButton.dialog.subject.ariaLabel' | transloco
          "
        >
          <ui-radio value="HAS_CONTRACTS">
            {{
              'cockpit.supplierContracts.contactButton.dialog.subject.hasContracts.label'
                | transloco
            }}
            <span
              class="block text-xs text-on-surface-variant dark:text-on-surface-variant-darkmode"
              >{{
                'cockpit.supplierContracts.contactButton.dialog.subject.hasContracts.description'
                  | transloco
              }}</span
            >
          </ui-radio>
          <ui-radio value="NO_CONTRACTS">
            {{
              'cockpit.supplierContracts.contactButton.dialog.subject.noContracts.label' | transloco
            }}
            <span
              class="block text-xs text-on-surface-variant dark:text-on-surface-variant-darkmode"
              >{{
                'cockpit.supplierContracts.contactButton.dialog.subject.noContracts.description'
                  | transloco
              }}</span
            >
          </ui-radio>
        </ui-radio-group>

        <ui-input-label>
          {{ 'cockpit.supplierContracts.contactButton.dialog.message.label' | transloco }}
          <span class="text-error dark:text-error-darkmode">*</span>
          <ui-textarea [formField]="contactForm.message" rows="10"></ui-textarea>
          <app-field-errors slot="bottom" [fieldState]="contactForm.message()" />
        </ui-input-label>
      </div>

      <app-http-error [error]="sendContactEmailState().error" slot="error">
        {{ 'cockpit.supplierContracts.contactButton.dialog.message.error' | transloco }}
      </app-http-error>

      <div slot="footer" class="flex gap-3 justify-end">
        <ui-button mode="outlined" (click)="dialog.close()" type="button">
          {{ 'cockpit.supplierContracts.contactButton.dialog.actions.cancel' | transloco }}
        </ui-button>
        <ui-button
          type="submit"
          [loading]="sendContactEmailState().isLoading"
          [disabled]="sendContactEmailState().isLoading"
        >
          {{ 'cockpit.supplierContracts.contactButton.dialog.actions.submit' | transloco }}
        </ui-button>
      </div>
    </ui-simple-dialog-layout>
  </form>
</ui-simple-dialog>
